import {
  DoctorProviderIconSVG,
  FacilityProviderIconSVG,
  DeleteIconSVG,
} from '../../../img/uploadDocument/uploadDocumentSVG';
import RadioInput from 'src/Admin/components/common/radio';
import GenericButton from '../../common/button/GenericButton/GenericButton';

const SelectedItemComponent = ({
  onChangeHandler,
  item,
  makeDataClear,
  isSearchScreen = false,
}) => {
  console.log(item, item?.OID, 'debug ITEM');
  const Specialty =
    item.Specialty && item.Specialty.split(',').map((item) => item.trim());
  console.log(Specialty, 'Specialty');
  return (
    <div
      className={`${
        isSearchScreen
          ? 'blob-list-item-border-added p-2'
          : 'blob-list-item-border'
      }`}
    >
      <div className="d-flex broker-list-item justify-content-between align-items-center">
        <div className="d-flex flex-1 align-items-center">
          <div className="d-flex my-auto">
            {!isSearchScreen && (
              <div className="pt-2">
                <RadioInput
                  type="checkbox"
                  id={item?.PhysicainOid + '_' + item?.FacilityOid}
                  name={!item?.isdummy ? item?.PhysicainOid : item?.FacilityOid}
                  className="p-0 mb-3"
                  onChange={onChangeHandler}
                  checked={item?.isChecked || false}
                />
              </div>
            )}
            <div className="">
              {!item?.isdummy ? (
                <DoctorProviderIconSVG className="document_providericonsvg" />
              ) : (
                <FacilityProviderIconSVG className="document_providericonsvg" />
              )}
            </div>
          </div>
          <div
            className={`${
              isSearchScreen ? 'pl-3' : 'pl-3 provider-name-address-container'
            }`}
          >
            <div>
              <span
                className={`${
                  isSearchScreen ? 'blob-item-name-1-added' : 'blob-item-name-1'
                }`}
              >
                {!item?.isdummy
                  ? item?.FirstName + ' ' + item?.LastName
                  : item?.FaciltyName}
              </span>
            </div>
            {item?.Specialty && (
              <div
                className={`${
                  isSearchScreen ? 'blob-item-desc-1-added' : 'blob-item-desc-1'
                }`}
              >
                {!isSearchScreen ? (
                  item?.Specialty
                ) : (
                  <>
                    {Specialty[0] && (
                      <span className={`${isSearchScreen ? 'text-char' : ''}`}>
                        {Specialty[0]}
                      </span>
                    )}
                    {Specialty[1] && (
                      <span className={`${isSearchScreen ? 'text-char' : ''}`}>
                        , {Specialty[1]}
                      </span>
                    )}
                  </>
                )}
                {Specialty.length > 2 && (
                  <span className={`${isSearchScreen ? 'more-spl' : ''}`}>
                    {' '}
                    +{Specialty.length - 2}
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="d-flex align-items-center">
          <div>
            {!item?.isdummy ? (
              <div>
                {item?.Physician_NPI && (
                  <div className="blob-item-desc-3">
                    NPI: {item?.Physician_NPI}
                  </div>
                )}
              </div>
            ) : (
              <div>
                {item?.Facility_NPI && (
                  <div className="blob-item-desc-3">
                    NPI: {item?.Facility_NPI}
                  </div>
                )}
              </div>
            )}

            <div>
              {item?.TaxID && (
                <div className="blob-item-desc-3">Tax ID: {item?.TaxID}</div>
              )}
            </div>
          </div>

          {isSearchScreen && (
            <div className="criteria-selection-block-action selection-block">
              <GenericButton
                className="pl-0 delete-cliteria-btn"
                variant="link"
                onClick={makeDataClear}
              >
                <DeleteIconSVG className={'deleteIconSVG'} />
              </GenericButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectedItemComponent;
